import { render, staticRenderFns } from "./serverDetail.vue?vue&type=template&id=69d98008&scoped=true&"
import script from "./serverDetail.vue?vue&type=script&lang=js&"
export * from "./serverDetail.vue?vue&type=script&lang=js&"
import style0 from "./serverDetail.vue?vue&type=style&index=0&id=69d98008&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d98008",
  null
  
)

export default component.exports